"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainlinkOracle = void 0;
exports.ChainlinkOracle = [
    {
        inputs: [
            {
                internalType: 'contract IDataFeed',
                name: '_dataFeed',
                type: 'address'
            },
            {
                internalType: 'uint256',
                name: '_decimals',
                type: 'uint256'
            }
        ],
        stateMutability: 'nonpayable',
        type: 'constructor'
    },
    {
        inputs: [],
        name: 'dataFeed',
        outputs: [
            {
                internalType: 'contract IDataFeed',
                name: '',
                type: 'address'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'decimals',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    },
    {
        inputs: [],
        name: 'getRate',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256'
            }
        ],
        stateMutability: 'view',
        type: 'function'
    }
];
//# sourceMappingURL=ChainlinkOracle.js.map